import { useEffect, useState, type ReactNode } from "react";
import { ChevronDown, Instagram, Linkedin, Mail, Menu, X, Youtube } from "lucide-react";
import { Link, NavLink } from "react-router-dom";
import { usePageAnimations } from "@/hooks/usePageAnimations";

const links = [
  ["Home", "/"],
  ["Soluções", "/solucoes"],
  ["Consultoria e Gestão", "/consultoria-e-gestao"],
  ["Educação", "/educacao"],
  ["Tecnologia", "/tecnologia"],
  ["Inteligência", "/inteligencia-imobiliaria"],
] as const;

const institutionalLinks = [
  ["Quem somos", "/o-sebraci"],
  ["Especialistas", "/especialistas"],
  ["Comunidade", "/comunidade"],
] as const;

export function PortalHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const update = () => setScrolled(window.scrollY > 32);
    update(); window.addEventListener("scroll", update, { passive: true });
    return () => window.removeEventListener("scroll", update);
  }, []);
  return <header className={`portal-nav ${scrolled ? "is-scrolled" : ""}`}>
    <Link to="/" className="portal-logo"><img src={scrolled ? "/images/sebraci-footer-logo.png" : "/images/sebraci-logo-cropped.png"} alt="SEBRACI — Serviço Brasileiro de Apoio ao Corretor de Imóveis" /></Link>
    <nav className={open ? "is-open" : ""}>
      <NavLink to="/" onClick={() => setOpen(false)}>Home</NavLink>
      <div className="portal-dropdown"><NavLink to="/o-sebraci" onClick={() => setOpen(false)}>O SEBRACI <ChevronDown /></NavLink><div className="portal-dropdown-menu">{institutionalLinks.map(([label, to]) => <NavLink key={to} to={to} onClick={() => setOpen(false)}>{label}</NavLink>)}</div></div>
      {links.slice(1).map(([label, to]) => <NavLink key={to} to={to} onClick={() => setOpen(false)}>{label}</NavLink>)}
      <a href="https://webmail.sebraci.org" target="_blank" rel="noreferrer" onClick={() => setOpen(false)}>WebMail</a>
      <Link className="portal-nav-cta" to="/contato" onClick={() => setOpen(false)}>Agendar diagnóstico</Link>
    </nav>
    <Link className="portal-diagnosis" to="/contato">Agendar diagnóstico</Link>
    <button className="portal-menu" onClick={() => setOpen(!open)} aria-label="Abrir menu">{open ? <X /> : <Menu />}</button>
  </header>;
}

export function PortalFooter() {
  return <footer className="portal-footer"><div className="portal-footer-grid">
    <div><Link to="/"><img src="/images/sebraci-footer-logo.png" alt="SEBRACI" /></Link><p>Desenvolvendo pessoas, empresas imobiliárias e o mercado para um Brasil melhor.</p><div className="portal-social"><a href="https://instagram.com/sebraci.oficial" target="_blank" rel="noreferrer" aria-label="Instagram"><Instagram /></a><a href="https://linkedin.com/company/sebraci" target="_blank" rel="noreferrer" aria-label="LinkedIn"><Linkedin /></a><a href="https://youtube.com/@sebraci" target="_blank" rel="noreferrer" aria-label="YouTube"><Youtube /></a></div></div>
    <div><h3>Institucional</h3><Link to="/o-sebraci">O SEBRACI</Link><Link to="/nossa-arquitetura">Nossa Arquitetura</Link><Link to="/especialistas">Especialistas</Link><Link to="/cases">Cases</Link><Link to="/comunidade">Comunidade</Link></div>
    <div><h3>Atuação</h3><Link to="/solucoes">Todas as Soluções</Link><Link to="/consultoria-e-gestao">Consultoria e Gestão</Link><Link to="/educacao">Educação</Link><Link to="/tecnologia">Tecnologia</Link><Link to="/inteligencia-imobiliaria">Inteligência Imobiliária</Link></div>
    <div><h3>Contato</h3><a href="mailto:sebraci@sebraci.org"><Mail /> sebraci@sebraci.org</a><a href="tel:+5585997301070">(85) 99730-1070</a><span>Fortaleza, CE — Brasil</span></div>
  </div><div className="portal-footer-bottom"><span>© 2026 SEBRACI. Todos os direitos reservados.</span><span>Orgulhosamente desenvolvido por <a href="https://www.serraconsultoria.com" target="_blank" rel="noreferrer">Serra Consultoria</a></span></div></footer>;
}

export function PortalShell({ children }: { children: ReactNode }) {
  usePageAnimations();
  return <div className="portal-site"><PortalHeader /><main>{children}</main><PortalFooter /></div>;
}
